import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate';
import base from '../shared/models/coreapi';
const store = new Vuex.Store({
    state: {
        isLogin: false,
        topMenus: [],
        fields: [],
        items: [],
        vendors: [],
        customers: [],
        uoms: [],
        branchs: [],
        filter: {
            Text: '',
            IsFilterDate: true,
            Page: 1,
            Total: 0,
            Limit: 25
        },
        routenum: 0,
        accounts: [],
        company: {},
        auth: {},
        companies: [],
        exchange: {}
    },
    mutations: {
        setMenu(state, menus){
            state.topMenus = menus;
        },
        updateAuthInfo(state, data){
            state.isLogin = true;
            state.auth = data;
        },
        updateCompany(state, data){
            state.companies = data;
        },
        selectCompany(state, payload){
            state.company = payload;
        },
        setExchange(state, data) {
            state.exchange = data;
        }
    },
    actions: {
        async verifyToken({ commit }){
            let jwt = localStorage.getItem(base.keyStorage);
            if(jwt != undefined && jwt != null){
                try {
                    let res = await base.api()({
                        method: 'POST',
                        url: 'account/verify',
                        headers: {
                            Authorization: 'Bearer ' + base.getToken()
                        }
                    });
                    if(res.status == 200){
                        commit('updateAuthInfo', res.data.Json.Auth);
                        commit('updateCompany', res.data.Json.Companies);
                        let compx = localStorage.getItem('compx');
                        if(compx != null)
                            commit('selectCompany', JSON.parse(compx));

                        let exchange = localStorage.getItem('exchange');
                        if (exchange != null)
                            commit('setExchange', JSON.parse(exchange));
                    }
                } catch (error) {
                    localStorage.removeItem(base.keyStorage);
                }
            }
        }
    },
    getters: {
        isCompanySelected: state => (state.company.Id != undefined && state.company.Id != '')
    },
    
});

export { store };